export default function (multiLang) {
    return {
        searchShareTable: {
            moduletype: 'table',
            code: 'searchShareTable',
            name: '查询方案管理表',
            //relationcode: 'body1',
            //areaVisible: false,
            isunfold: true,
            items: [
                // {
                //     label: '所属分组',
                //     attrcode: 'classfication',
                //     key: 'classfication',
                //     width: 100,
                //     itemtype: 'input',
                //     visible: true,
                // },
                {
                    label: multiLang['page-search-0012'] || '方案名称',
                    attrcode: 'schema_name',
                    key: 'schema_name',
                    width: 100,
                    itemtype: 'input',
                    visible: true,
                    // disabled:true

                },
                {
                    label: multiLang['page-search-0157'] || '是否默认',
                    attrcode: 'default_schema',
                    key: 'default_schema',
                    width: 100,
                    itemtype: 'switch',
                    visible: true,
                    // disabled:true

                },
                {
                    label: multiLang['page-search-0152'] || '是否显示',
                    attrcode: 'show_schema',
                    key: 'show_schema',
                    width: 100,
                    itemtype: 'switch',
                    visible: true,
                    // disabled:true

                },
                {
                    label: multiLang['page-search-0153'] ||'分享人',
                    attrcode: 'sharer',
                    key: 'sharer',
                    width: 100,
                    itemtype: 'input',
                    visible: true,
                    // disabled:true
                },
                // {
                //     label: '附件',
                //     color: 'red',
                //     attrcode: 'uplaoder',
                //     itemtype: 'attachment',
                //     visible: true,
                // },
                // {
                //     label: '员工编号',
                //     attrcode: 'a',
                //     color: 'red',
                //     initialvalue: { value: '2020-06-16' },
                //     key: 'a',
                //     width: 150,
                //     itemtype: 'datepicker',
                //     visible: true,
                //     children: [
                //         {
                //             itemtype: 'select',
                //             visible: true,
                //             label: '单选',
                //             color: 'red',
                //             width: '200px',
                //             options: [
                //                 {
                //                     display: '难',
                //                     value: 'Y',
                //                 },
                //                 {
                //                     display: '易',
                //                     value: 'N',
                //                 },
                //             ],
                //             attrcode: 'single45',
                //         },
                //         {
                //             itemtype: 'select',
                //             visible: true,
                //             label: '单选',
                //             width: '200px',
                //             options: [
                //                 {
                //                     display: '是',
                //                     value: 'Y',
                //                 },
                //                 {
                //                     display: '否',
                //                     value: 'N',
                //                 },
                //             ],
                //             attrcode: 'single23',
                //         },
                //     ],
                // },

                // {
                //     label: '员工姓名',
                //     attrcode: 'b',
                //     key: 'b',
                //     width: 100,
                //     itemtype: 'number',
                //     visible: false,
                //     scale: 2,
                // },
                // {
                //     label: 'checkbox_switch',
                //     attrcode: 'checkbox_switch',
                //     key: 'checkbox_switch',
                //     width: 100,
                //     itemtype: 'checkbox_switch',
                //     visible: true,
                // },
                // {
                //     label: '编辑前测试1',
                //     attrcode: 'bj1',
                //     key: 'bj1',
                //     width: 100,
                //     itemtype: 'input',
                //     visible: false,
                // },
                // {
                //     label: '编辑前测试2',
                //     attrcode: 'bj2',
                //     key: 'bj2',
                //     width: 100,
                //     itemtype: 'input',
                //     visible: true,
                // },
                // {
                //     label: '校验测试1',
                //     attrcode: 'valid1',
                //     key: 'valid1',
                //     width: 100,
                //     itemtype: 'number',
                //     visible: true,
                //     required: true,
                // },
                // {
                //     label: '默认值测试1',
                //     attrcode: 'dv1',
                //     key: 'dv1',
                //     width: 100,
                //     itemtype: 'input',
                //     visible: true,
                //     initialvalue: { display: '张三', value: '1212' },
                // },
                // {
                //     label: '性别',
                //     attrcode: 'c',
                //     key: 'c',
                //     width: 100,
                //     itemtype: 'select',
                //     options: [
                //         {
                //             display: '男',
                //             value: '0',
                //         },
                //         {
                //             display: '女',
                //             value: '1',
                //         },
                //     ],
                //     visible: true,
                // },
                // {
                //     label: '校验测试33',
                //     attrcode: 'valid33',
                //     key: 'valid33',
                //     width: 100,
                //     itemtype: 'input',
                //     visible: true,
                //     required: false,
                // },
                // {
                //     label: '折行测试',
                //     attrcode: 'fold',
                //     key: 'fold',
                //     width: 100,
                //     itemtype: 'input',
                //     visible: true,
                // },
                // {
                //     label: '默认值测试4',
                //     attrcode: 'dv4',
                //     key: 'dv4',
                //     width: 100,
                //     itemtype: 'number',
                //     visible: true,
                //     initialvalue: { display: '张三', value: '1212' },
                // },
                // // {
                // //     label: "数值类型", attrcode: "a",
                // //     key: "a", width: 150, itemtype: "number", visible: true
                // // },
                // {
                //     label: 'datepicker',
                //     attrcode: 'datepicker',
                //     key: 'datepicker',
                //     width: 100,
                //     itemtype: 'datepicker',
                //     visible: true,
                // },
                // {
                //     label: 'timepicker',
                //     attrcode: 'timepicker',
                //     key: 'timepicker',
                //     width: 100,
                //     itemtype: 'timepicker',
                //     visible: true,
                // },
                // {
                //     label: 'datetimepicker',
                //     attrcode: 'datetimepicker',
                //     key: 'datetimepicker',
                //     width: 100,
                //     itemtype: 'datetimepicker',
                //     visible: true,
                // },
                // {
                //     label: 'NCTZDatePickerStart',
                //     attrcode: 'NCTZDatePickerStart',
                //     key: 'NCTZDatePickerStart',
                //     width: 100,
                //     itemtype: 'NCTZDatePickerStart',
                //     visible: true,
                // },
                // {
                //     label: 'datePickerNoTimeZone',
                //     attrcode: 'datePickerNoTimeZone',
                //     key: 'datePickerNoTimeZone',
                //     width: 100,
                //     itemtype: 'datePickerNoTimeZone',
                //     visible: true,
                // },
            ],
            isCustomMeta:true
        },
    };
}
